module.exports = __webpack_public_path__ + "img/language.bea6c082.svg";